import React from 'react'
import css from './style.scss'

export default ({ children }) => (
  <div className={css.metricsNumber}>
    {children}
  </div>
)
